import axios from "axios";
import { T, APIS } from "../../Constants";

const { IMPORT_API } = APIS;

type GetEquipImportResources = T.API.ToAxios<T.API.Utils.Import.GetEquipImportResources>;

/** Get all the resources necessary for an equipment import */
export const getEquipImportResources: GetEquipImportResources = building => axios.get(IMPORT_API + "data/equip", { params: { building } });